import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { TIERS } from './adminOfficesApi';

export const PlanAndLimitControls = ({ practice: p, openCount, act, api, confirm }) => {
  const [limit, setLimit] = useState(p.override == null ? '' : String(p.override));
  return (
    <div className="grid gap-4 sm:grid-cols-2 bg-white border rounded-xl p-4" data-testid={`admin-plan-controls-${p.id}`}>
      <label className="grid gap-1 text-sm font-medium">
        Plan (no charge to the practice)
        <select value={p.tier} className="h-10 rounded-md border px-3" data-testid={`admin-plan-select-${p.id}`}
          onChange={async (e) => { const t = e.target.value; if (await confirm({ title: `Switch ${p.name} to ${t}?`, text: 'This changes their features and limits right away. It does not change their Stripe billing.', ok: 'Switch plan' }))
            act(() => api.setPlan(p.id, t, p.status), `Plan set to ${t}`); }}>
          {TIERS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <span className="text-xs text-slate-500 font-normal">
          Status: <select value={p.status || 'active'} className="border rounded px-1" data-testid={`admin-status-select-${p.id}`}
            onChange={(e) => act(() => api.setPlan(p.id, p.tier, e.target.value), `Status set to ${e.target.value}`)}>
            {['trial', 'active', 'past_due', 'canceled'].map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          {p.pendingChange && <> · switching to {p.pendingChange.tier} on {new Date(p.pendingChange.effectiveAt).toLocaleDateString()}</>}
        </span>
      </label>
      <div className="grid gap-1 text-sm font-medium">
        Office limit · now {p.limit == null ? 'unlimited' : p.limit} ({openCount} open){p.override != null ? ' · custom' : ' · plan default'}
        <div className="flex gap-2">
          <Input value={limit} onChange={(e) => setLimit(e.target.value)} placeholder="Plan default" data-testid={`admin-limit-input-${p.id}`} />
          <Button size="sm" variant="outline" data-testid={`admin-limit-save-${p.id}`}
            onClick={() => act(() => api.setLimit(p.id, limit.trim() === '' ? null : limit.trim().toLowerCase()), 'Office limit saved')}>Save</Button>
          <Button size="sm" variant="ghost" data-testid={`admin-limit-unlimited-${p.id}`}
            onClick={() => { setLimit('unlimited'); act(() => api.setLimit(p.id, 'unlimited'), 'Office limit set to unlimited'); }}>Unlimited</Button>
        </div>
        <span className="text-xs text-slate-500 font-normal">Type a number, "unlimited", or leave empty to use the plan default.</span>
      </div>
    </div>
  );
};
